import React from 'react';
import { createSessionStatusController, SESSION_STATUS } from './session-status.js';

const controller = createSessionStatusController();

function getServerSnapshot() {
  return SESSION_STATUS.UNKNOWN;
}

/**
 * Browser session hint for commercial-site UI. This never exposes or persists
 * an App session payload, and server rendering always receives `unknown`.
 */
export function useSessionStatus() {
  return React.useSyncExternalStore(
    controller.subscribe,
    controller.getSnapshot,
    getServerSnapshot,
  );
}
